
// Recursive Javascript program to check if
// a string is subsequence of another string

// Returns true if str1[] is a
// subsequence of str2[] m is
// length of str1 and n is length
// of str2
import store from "@/store";
import echo from "laravel-echo";
import Config from "@/config";
import {notify} from "@kyvg/vue3-notification";
import moment from "moment";
import ComplainService from "@/services/complain.service";

export function isSubSequence(str1, str2, m, n) {

    // Base Cases
    if (m == 0) return true;
    if (n == 0) return false;

    // If last characters of two strings
    // are matching
    if (str1[m - 1] == str2[n - 1]) return isSubSequence(str1, str2, m - 1, n - 1);

    // If last characters are not matching
    return isSubSequence(str1, str2, m, n - 1);
}

export function numberOnly(evt) {
    const key = evt.keyCode
    const char = String.fromCharCode((96 <= key && key <= 105) ? key - 48 : key)
    if (![8, 10, 13, 46].includes(evt.keyCode) && !/[0-9]/.test(char)) {
        evt.preventDefault()
    }
}

export function getYesNo(v) {
    if (v) {
        v = v.toUpperCase()
        if (['Y', 'YES', 1, '1'].includes(v)) return 'Yes';
        if (['N', 'NO', 'N/A', 0, '0', ''].includes(v)) return 'No';
    }
    return v;
}

String.prototype.hasSubSequence = function (target) {
    return isSubSequence(target, this, target.length, this.length)
}

export function has_permission(permission_key) {
    let user = store.state.auth.user;
    if (!user) return false;
    let permissions = user.permissions;
    return permissions['grant_all'] || permissions[permission_key];
}

export function initializePusher() {
    window.Pusher = require('pusher-js');
    let user = JSON.parse(localStorage.getItem('user'));
    let token = '';
    if (user && user.token) {
        token = user.token;
        let system = {...store.state.system.settings};
        let pusherOpts = {
            authEndpoint: Config.apiBasePath + '/broadcasting/auth',
            broadcaster: 'pusher',
            key: system.pusher_key,
            wsHost: system.pusher_host,
            wsPath: system.pusher_path_prefix,
            forceTLS: system.pusher_scheme === 'https',
            disableStats: true,
            //cluster: 'eu',
            encrypted: system.pusher_scheme === 'https',
            auth: {
                headers: {
                    Authorization: 'Bearer ' + token
                },
            }
        };
        if (system.pusher_scheme === 'https') {
            pusherOpts.wssPort = system.pusher_port;
        } else {
            pusherOpts.wsPort = system.pusher_port;
        }
        window.Echo = new echo(pusherOpts);
    }
}

export function notifyError(e) {
    notify({
        'type': 'error',
        'title': 'Error',
        'text': extractError(e),
    })
}

export function extractError(e) {
    let err = e;
    if (typeof e === 'object') {
        if (e.response && e.response.data) {
            err = e.response.data.error || e.response.data.message || e.message || err;
        } else {
            err = e.error || e.message || err;
        }
    }
    return err;
}

export function getInitialTime(elapsedTime) {
    const [minutes, seconds] = elapsedTime.split(':').map(Number);
    const callWaitingTime = moment.duration({
        minutes: minutes,
        seconds: seconds
    });
    const currentDatetime = moment();
    const startingDatetime = currentDatetime.subtract(callWaitingTime);
    return startingDatetime.format('YYYY-MM-DD HH:mm:ss');
}

export function secToDuration(seconds, translator = null) {
    const translate = (input) => {
        if (translator) {
            return input.split(':').map(i => String(translator.n(parseInt(i))).padStart(2, translator.n(0))).join(':');
        }
        return input;
    };
    seconds = parseInt(seconds);
    if (isNaN(seconds)) return translate('00:00:00');
    let hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    let minutes = Math.floor(seconds / 60);
    seconds %= 60;
    return translate(String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0'));
}

export async function downloadAttachment(attachment, type) {
    const download = async (item) => {
        const decodedData = window.atob(item.file_content);
        const uInt8Array = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        const url = window.URL.createObjectURL(new Blob([uInt8Array], {type: item.file_type}));
        window.open(url);
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    };
    let item = {...attachment};
    if (item.id) {
        try {
            let response;
            switch (type) {
                case 'resolution':
                    response = await ComplainService.getResolutionAttachment(item.id);
                    item = response.data.data;
                    break;
            }
        } catch (e) {
            notifyError(e);
            return;
        }
    } else {
        const parts = item.file_content.split(';base64,');
        item.file_content = parts[1];
    }
    await download(item);
}

export function getBaseUrl() {
    const allowed_bases = new Set(['/cc-crm']);
    for (let p of allowed_bases) {
        if (window.location.pathname.startsWith(p)) {
            return p;
        }
    }
    return '';
}

export function resolvePath(path) {
    return getBaseUrl() + path;
}
